import { z } from "zod";

import { idSchema } from "./parcellaire.js";

/** Borne technique de saisie par matière et opération, en unités. */
const NB_FOURNITURES_MAX = 1_000_000;

/** Article et lot physiquement prélevés, avec les pertes séparées de la pose. */
export const matierePoseeSchema = z.object({
  article_id: idSchema,
  numero_lot_fournisseur: z.string().trim().min(1).max(64),
  nb_poses: z.number().int().min(0).max(NB_FOURNITURES_MAX),
  nb_abimes: z.number().int().min(0).max(NB_FOURNITURES_MAX).default(0),
});
export type MatierePosee = z.infer<typeof matierePoseeSchema>;
